export default "__VITE_ASSET__2a4663ca__"